import { useQuery } from '@tanstack/react-query';
import {
  fetchWebsiteLeads,
  fetchLeadMatches,
  fetchTodayLeadsByCity,
} from '../api/leads';
import type { FilterState } from '@/types/lead-attribution';
import type { PaginationState } from '../types';

export const useWebsiteLeads = (
  filters: FilterState,
  pagination?: PaginationState
) => {
  return useQuery({
    queryKey: ['website-leads', filters, pagination],
    queryFn: () => fetchWebsiteLeads(filters, pagination),
  });
};

export const useLeadMatches = (filters: FilterState, searchTerm?: string) => {
  return useQuery({
    queryKey: ['lead-matches', filters, searchTerm],
    queryFn: () => fetchLeadMatches(filters),
  });
};

export const useTodayLeadsByCity = (city: string) => {
  return useQuery({
    queryKey: ['today-leads-city', city],
    queryFn: () => fetchTodayLeadsByCity(city),
  });
};
